import React from 'react';
import { Box } from '@mui/material';

import InventoryCard from './components/InventoryCard';
import SalesCard from './components/SalesCard';
import RestockCard from './components/RestockCard';
import AlertsCard from './components/AlertsCard';
import TopSellingCard from './components/TopSellingCard';
import AnalyticsCard from './components/AnalyticsCard';

const Dashboard = () => {
  const cards = [
    { Component: InventoryCard, col: 1, rowStart: 1, rowSpan: 3 },
    { Component: TopSellingCard, col: 1, rowStart: 4, rowSpan: 6 },
    { Component: RestockCard, col: 1, rowStart: 10, rowSpan: 3 },

    { Component: AlertsCard, col: 2, rowStart: 1, rowSpan: 4 },
    { Component: RestockCard, col: 2, rowStart: 5, rowSpan: 3 },
    { Component: AnalyticsCard, col: 2, rowStart: 8, rowSpan: 5 },

    { Component: SalesCard, col: 3, rowStart: 1, rowSpan: 7 },
    { Component: InventoryCard, col: 3, rowStart: 8, rowSpan: 5 },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'grid',
        gap: 2,
        padding: 2,
        boxSizing: 'border-box',

        // Responsive grid setup
        gridTemplateColumns: {
          xs: '1fr',               // 1 column on mobile
          sm: 'repeat(2, 1fr)',    // 2 columns on small tablets
          md: 'repeat(3, 1fr)',    // 3 columns on desktop
        },

        // You can choose to let rows auto-adjust on smaller screens
        gridAutoRows: {
          xs: 'auto',              // auto height rows on mobile
          md: '1fr',               // fixed rows on desktop
        },
      }}
    >
      {cards.map((card, index) => {
        const { Component } = card;

        if (!Component) {
          console.warn(`Component at index ${index} is undefined`);
          return null;
        }

        const isSalesCard = Component.name === 'SalesCard';

        return (
          <Box
            key={index}
            sx={{
              // On desktop, use manual grid positioning
              gridColumn: {
                xs: 'auto', // let it flow naturally on mobile
                md: card.col,
              },
              gridRow: {
                xs: 'auto', // natural stacking on mobile
                md: `${card.rowStart} / span ${card.rowSpan}`,
              },

              backgroundColor: isSalesCard ? 'transparent' : '#fff',
              borderRadius: 2,
              boxShadow: isSalesCard ? 'none' : '0 4px 8px rgba(0,0,0,0.1)',
              overflow: 'hidden',
            }}
          >
            <Component />
          </Box>
        );
      })}
    </Box>
  );
};

export default Dashboard;
